export const PI_2 = Math.PI * 2;
export const PI_HALF = Math.PI / 2;
export const FPS_60 = 1 / 0.016;
